export const I18N_PREFIX = 'commons.header-info';
